import { chakra, useColorModeValue } from '@chakra-ui/react'

export function Logo (props) {

    var textColor = useColorModeValue("secondaryGray.900", "white");

    return(
    <chakra.svg
        align="center" width="80%" x="0px" y="0px" viewBox="0 0 950 250" xmlns="http://www.w3.org/2000/svg" >
        <path
            fill="#88bf40"
            d="M212.8 138.7s-45.5-46.2-116.5-10.9c-5 2.4-52.6 18.6-88.3-9.8-.1.2 33.6 59.8 96 36.9 10.6-3.8 64-27.4 108.8-16.2z"
        />
        <linearGradient
            id="a"
            x1="80.513"
            x2="235.749"
            y1="108.668"
            y2="108.668"
            gradientTransform="rotate(-5.498 438.512 366.876)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".117" stop-color="#079247" />
            <stop offset=".597" stop-color="#8dc641" />
        </linearGradient>
        <path
            fill="url(#a)"
            d="M164.4 115.8c-29.1 9.7-53 26.4-59.5 30.4-16.7 10.3-32.4 13-46.3 11.7 12.8 3.3 27.9 3.4 45.3-3 10.6-3.9 64-27.5 108.8-16.2.1 0-17.6-18-48.3-22.9z"
        />
        <linearGradient
            id="b"
            x1="108.836"
            x2="134.585"
            y1="58.424"
            y2="53.874"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" stop-color="#f69e33" />
            <stop offset="1" stop-color="#bf7730" />
        </linearGradient>
        <path
            fill="url(#b)"
            d="M30.7 80.5c0-27.6 22.4-50 50-50s50 22.4 50 50c0 11.2-3.7 21.5-9.9 29.8h.1c8.3-10.9 13.3-24.6 13.3-39.4 0-36-29.2-65.2-65.2-65.2-6.2 0-12.3.9-18 2.5-22.8 9.1-40 28.7-46.5 52.5-.5 3.3-.8 6.7-.8 10.2 0 19.9 9.1 37.2 23 49.2 12.6 5.3 25.4 7.3 36.3 7.3-18.9-7.2-32.3-25.4-32.3-46.9z"
        />
        <linearGradient
            id="c"
            x1="3.81"
            x2="3.81"
            y1="60.182"
            y2="69.734"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" stop-color="#f79421" />
            <stop offset="1" stop-color="#fed522" />
        </linearGradient>
        <path
            fill="url(#c)"
            d="M3 67.8c.4-2.4.9-4.7 1.6-7 0-.1 0-.3.1-.4-.7 2.4-1.3 4.9-1.7 7.4z"
        />
        <linearGradient
            id="d"
            x1="51.755"
            x2="51.755"
            y1="7.575"
            y2="8.419"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" stop-color="#f79421" />
            <stop offset="1" stop-color="#fed522" />
        </linearGradient>
        <path
            fill="url(#d)"
            d="M50.9 8.2s.1 0 0 0c.6-.2 1.1-.5 1.7-.7-.6.3-1.1.5-1.7.7z"
        />
        <radialGradient
            id="e"
            cx="63.927"
            cy="48.5"
            r="89.041"
            gradientTransform="matrix(-.8966 -.4429 .3457 -.6999 104.476 110.757)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".01" stop-color="#f69e33" stop-opacity="0" />
            <stop offset=".531" stop-color="#f69e33" />
            <stop offset="1" stop-color="#bf7730" />
        </radialGradient>
        <path
            fill="url(#e)"
            d="M30.7 80.6c0-27.6 22.4-50 50-50s50 22.4 50 50c0 11.2-3.7 21.5-9.9 29.8h.1c8.3-10.9 13.3-24.6 13.3-39.4C134.2 35 105 5.8 69 5.8c-6.2 0-12.3.9-18 2.5-22.7 9.1-40 28.6-46.4 52.5-.6 3.3-.8 6.7-.8 10.1 0 19.9 9.1 37.2 23 49.2 12.6 5.3 25.4 7.3 36.3 7.3-18.9-7.1-32.4-25.4-32.4-46.8z"
        />
        <path
            fill="#fdef28"
            d="M134.2 70.9c0 14.8-4.9 28.5-13.3 39.4 12.3-3.9 23.7-5.4 34-5.3 2.5-7.6 3.8-15.7 3.8-24.1 0-43.3-35.1-78.4-78.4-78.4h-4c-.3 0-.6 0-.9.1-.3 0-.7 0-1 .1-.3 0-.7.1-1 .1-.3 0-.6 0-.9.1-.4 0-.7.1-1.1.1-.3 0-.5.1-.8.1-.4 0-.8.1-1.2.2-.2 0-.5.1-.7.1-.4.1-.8.1-1.2.2-.2 0-.4.1-.6.1-.4.1-.9.2-1.3.2-.2 0-.4.1-.6.1-.4.1-.9.2-1.3.3-.2 0-.3.1-.5.1-.5.1-.9.2-1.4.3-.1 0-.3.1-.4.1-.5.1-1 .2-1.4.4-.1 0-.2.1-.3.1-.5.1-1 .3-1.5.4-.1 0-.2.1-.3.1-.5.2-1 .3-1.5.5-.1 0-.1 0-.2.1-.5.2-1.1.4-1.6.5h-.1c-.5.2-1.1.4-1.6.6h-.1c-.8.3-1.3.5-1.9.7C56.7 6.6 62.7 5.7 69 5.7c36 0 65.2 29.2 65.2 65.2z"
        />
        <g>
            <path
                fill="none"
                d="M130.7 80.6c0-27.6-22.4-50-50-50s-50 22.4-50 50c0 21.4 13.5 39.7 32.4 46.8 14.1 0 24.8-2.7 27.1-3.6 8.7-3.3 17-5.6 24.8-6.9 9.7-9.1 15.7-22 15.7-36.3z"
            />
            <linearGradient
                id="f"
                x1="77.946"
                x2="77.946"
                y1="2.555"
                y2="166.062"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#f)" d="M77.6 2.6h.7-.7z" />
            <linearGradient
                id="g"
                x1="73.881"
                x2="73.881"
                y1="2.556"
                y2="159.669"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#g)" d="M73.4 2.9c.3 0 .7-.1 1-.1-.4 0-.7 0-1 .1z" />
            <linearGradient
                id="h"
                x1="68.044"
                x2="68.044"
                y1="2.55"
                y2="160.435"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#h)" d="M67.4 3.6c.4-.1.8-.1 1.2-.2-.4.1-.8.1-1.2.2z" />
            <linearGradient
                id="i"
                x1="56.972"
                x2="56.972"
                y1="2.559"
                y2="159.211"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#i)" d="M56.2 6.3c.5-.2 1-.3 1.5-.5-.5.2-1 .4-1.5.5z" />
            <linearGradient
                id="j"
                x1="71.91"
                x2="71.91"
                y1="2.554"
                y2="160.061"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#j)" d="M71.4 3.1c.4 0 .7-.1 1.1-.1-.4 0-.8 0-1.1.1z" />
            <linearGradient
                id="k"
                x1="66.142"
                x2="66.142"
                y1="2.556"
                y2="159.364"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#k)" d="M65.5 4c.4-.1.9-.2 1.3-.2-.4 0-.9.1-1.3.2z" />
            <linearGradient
                id="l"
                x1="75.881"
                x2="75.881"
                y1="2.557"
                y2="159.24"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#l)" d="M75.4 2.7c.3 0 .6 0 .9-.1-.3.1-.6.1-.9.1z" />
            <linearGradient
                id="m"
                x1="60.571"
                x2="60.571"
                y1="2.565"
                y2="158.772"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#m)" d="M59.8 5.3c.5-.1 1-.3 1.4-.4-.4.1-.9.2-1.4.4z" />
            <linearGradient
                id="n"
                x1="69.965"
                x2="69.965"
                y1="2.559"
                y2="158.702"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#n)" d="M69.4 3.3c.4-.1.8-.1 1.2-.2-.4.1-.8.2-1.2.2z" />
            <linearGradient
                id="o"
                x1="62.407"
                x2="62.407"
                y1="2.551"
                y2="159.746"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#o)" d="M61.7 4.8c.5-.1.9-.2 1.4-.3-.5.1-.9.2-1.4.3z" />
            <linearGradient
                id="p"
                x1="53.467"
                x2="53.467"
                y1="2.553"
                y2="159.444"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path
                fill="url(#p)"
                d="M52.7 7.6c.5-.2 1.1-.4 1.6-.6-.6.2-1.1.4-1.6.6z"
            />
            <linearGradient
                id="q"
                x1="58.762"
                x2="58.762"
                y1="2.555"
                y2="159.393"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#q)" d="M58 5.8c.5-.1 1-.3 1.5-.4-.5.1-1 .2-1.5.4z" />
            <linearGradient
                id="r"
                x1="55.208"
                x2="55.208"
                y1="2.563"
                y2="159.129"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path
                fill="url(#r)"
                d="M54.4 6.9c.5-.2 1.1-.4 1.6-.5-.5.2-1.1.3-1.6.5z"
            />
            <linearGradient
                id="s"
                x1="64.265"
                x2="64.265"
                y1="2.555"
                y2="159.426"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f79421" />
                <stop offset="1" stop-color="#fed522" />
            </linearGradient>
            <path fill="url(#s)" d="M63.6 4.3c.4-.1.9-.2 1.3-.3-.4.2-.9.2-1.3.3z" />
            <path
                fill="#fdef28"
                d="M59.4 127.4c1 0 2 0 3-.1-35-8.6-60.8-41.1-52.2-76.1 1.5-6.1 3.8-11.8 6.8-16.9-.4.5-.7 1-1 1.5v.1c-.3.5-.7 1-1 1.4l-.1.1c-.3.5-.6.9-.9 1.4 0 .1-.1.1-.1.2-.3.5-.6.9-.8 1.4 0 .1-.1.2-.1.2-.3.4-.5.9-.8 1.3-.1.1-.1.2-.2.3-.2.4-.5.9-.7 1.3-.1.1-.1.3-.2.4-.2.4-.4.8-.6 1.3-.1.2-.1.3-.2.5l-.6 1.2c-.1.2-.2.4-.2.5-.2.4-.4.8-.5 1.2l-.3.6c-.2.4-.3.8-.5 1.1-.1.2-.2.5-.3.7-.1.4-.3.7-.4 1.1-.1.3-.2.5-.3.8-.1.3-.3.7-.4 1l-.3.9c-.1.3-.2.6-.3 1-.1.3-.2.7-.3 1l-.3.9-.3 1.2c-.2.2-.3.4-.3.6-.2.6-.3 1.3-.5 1.9C.6 77.2 1.7 93 6.9 107.2c13.9 12.6 32.3 20.2 52.5 20.2z"
            />
        </g>
        <g fill={textColor}>
            <path d="m229.9 55-8.2 7.2c-2.9-4-5.8-6-8.8-6-1.4 0-2.6.4-3.6 1.2-.9.8-1.4 1.7-1.4 2.6 0 1 .3 1.9 1 2.8.9 1.2 3.6 3.6 8.1 7.5 4.2 3.5 6.8 5.7 7.7 6.7 2.2 2.3 3.8 4.4 4.8 6.5.9 2.1 1.4 4.3 1.4 6.8 0 4.8-1.6 8.7-4.9 11.8-3.3 3.1-7.6 4.7-12.9 4.7-4.1 0-7.7-1-10.8-3s-5.7-5.2-7.9-9.5l9.3-5.6c2.8 5.1 6 7.7 9.6 7.7 1.9 0 3.5-.6 4.8-1.7 1.3-1.1 1.9-2.4 1.9-3.8 0-1.3-.5-2.6-1.5-3.9-1-1.3-3.1-3.3-6.4-6-6.3-5.2-10.4-9.1-12.2-11.9-1.8-2.8-2.8-5.6-2.8-8.4 0-4 1.5-7.5 4.6-10.4 3.1-2.9 6.8-4.3 11.4-4.3 2.9 0 5.7.7 8.3 2 2.6 1 5.4 3.5 8.5 7zM271.9 62.2h10.8v42.9h-10.8v-4.5c-2.1 2-4.2 3.4-6.3 4.3-2.1.9-4.4 1.3-6.9 1.3-5.5 0-10.3-2.1-14.4-6.4-4-4.3-6.1-9.6-6.1-16 0-6.6 2-12.1 5.9-16.3 3.9-4.2 8.7-6.3 14.3-6.3 2.6 0 5 .5 7.2 1.5 2.3 1 4.3 2.4 6.3 4.4v-4.9zm-11.3 8.9c-3.3 0-6.1 1.2-8.3 3.5-2.2 2.4-3.3 5.4-3.3 9 0 3.7 1.1 6.8 3.4 9.1 2.2 2.4 5 3.6 8.3 3.6 3.4 0 6.2-1.2 8.4-3.5 2.2-2.4 3.3-5.4 3.3-9.2 0-3.7-1.1-6.8-3.3-9.1-2.3-2.3-5.1-3.4-8.5-3.4zM288.4 62.2h3.8c0-5.6.1-9 .3-10 .3-2.4 1.3-4.2 3-5.6 1.7-1.4 4.1-2.1 7.2-2.1 2.2 0 4.8.5 7.6 1.5v8.2c-1.6-.4-2.8-.7-3.8-.7-1.3 0-2.2.3-2.8.8-.4.4-.6 1.2-.6 2.4v5.4h6.8v9.1H303V105h-10.8V71.3h-3.8v-9.1zM347.8 62.2h10.8v42.9h-10.8v-4.5c-2.1 2-4.2 3.4-6.3 4.3-2.1.9-4.4 1.3-6.9 1.3-5.5 0-10.3-2.1-14.4-6.4-4-4.3-6.1-9.6-6.1-16 0-6.6 2-12.1 5.9-16.3 3.9-4.2 8.7-6.3 14.3-6.3 2.6 0 5 .5 7.2 1.5 2.3 1 4.3 2.4 6.3 4.4v-4.9zm-11.3 8.9c-3.3 0-6.1 1.2-8.3 3.5-2.2 2.4-3.3 5.4-3.3 9 0 3.7 1.1 6.8 3.4 9.1 2.2 2.4 5 3.6 8.3 3.6 3.4 0 6.2-1.2 8.4-3.5 2.2-2.4 3.3-5.4 3.3-9.2 0-3.7-1.1-6.8-3.3-9.1-2.3-2.3-5.1-3.4-8.5-3.4zM366.9 62.2h9.2v5.4c1-2.1 2.3-3.7 4-4.9 1.7-1.1 3.5-1.7 5.4-1.7 1.4 0 2.9.4 4.4 1.1l-3.4 9.3c-1.3-.6-2.3-.9-3.1-.9-1.7 0-3.1 1-4.2 3.1s-1.7 6.1-1.7 12.1v19.5h-10.7v-43zM399.5 44.6c1.9 0 3.5.7 4.9 2.1 1.4 1.4 2 3 2 5 0 1.9-.7 3.6-2 4.9-1.3 1.4-2.9 2-4.8 2s-3.5-.7-4.9-2.1c-1.4-1.4-2-3.1-2-5s.7-3.5 2-4.9c1.3-1.4 2.9-2 4.8-2zm-5.4 17.6h10.8v42.9h-10.8V62.2zM438.7 47.1h33.2v5.7h-27.4V71h27.2v5.7h-27.2v22.8h27.2v5.7h-33V47.1zM481 62.2h5.5v7.7c2.2-2.9 4.7-5.1 7.3-6.6 2.7-1.5 5.6-2.2 8.8-2.2 3.2 0 6.1.8 8.5 2.4 2.5 1.6 4.3 3.8 5.5 6.6 1.2 2.8 1.8 7.1 1.8 12.9v22.1h-5.5V84.7c0-4.9-.2-8.2-.6-9.9-.6-2.8-1.9-5-3.7-6.4-1.8-1.4-4.2-2.1-7.1-2.1-3.3 0-6.3 1.1-9 3.3-2.6 2.2-4.4 4.9-5.2 8.2-.5 2.1-.8 6-.8 11.7v15.7H481v-43zM566.4 90.9l4.7 2.4c-1.5 3-3.3 5.4-5.3 7.3-2 1.8-4.2 3.2-6.7 4.2s-5.3 1.4-8.5 1.4c-7 0-12.5-2.3-16.4-6.9-3.9-4.6-5.9-9.8-5.9-15.6 0-5.4 1.7-10.3 5-14.6 4.2-5.4 9.9-8.1 17-8.1 7.3 0 13.2 2.8 17.5 8.3 3.1 3.9 4.7 8.8 4.7 14.7h-38.6c.1 5 1.7 9.1 4.8 12.3 3.1 3.2 6.9 4.8 11.4 4.8 2.2 0 4.3-.4 6.4-1.1 2.1-.8 3.8-1.8 5.3-3 1.3-1.3 2.9-3.3 4.6-6.1zm0-11.6c-.7-2.9-1.8-5.3-3.2-7.1-1.4-1.8-3.3-3.2-5.6-4.3-2.3-1.1-4.8-1.6-7.3-1.6-4.2 0-7.8 1.4-10.9 4.1-2.2 2-3.9 4.9-5 8.9h32zM580.7 62.2h5.6v6.3c1.7-2.5 3.5-4.3 5.3-5.5s3.8-1.8 5.8-1.8c1.5 0 3.2.5 4.9 1.5l-2.9 4.7c-1.2-.5-2.1-.7-2.9-.7-1.8 0-3.6.8-5.3 2.3-1.7 1.5-3 3.9-3.9 7-.7 2.4-1 7.4-1 14.8v14.5h-5.6V62.2zM644 62.2h5.5v34.2c0 6-.5 10.4-1.6 13.2-1.4 3.9-4 7-7.5 9.1-3.6 2.1-7.9 3.2-12.9 3.2-3.7 0-7-.5-9.9-1.6-2.9-1-5.3-2.4-7.2-4.2-1.8-1.8-3.5-4.3-5.1-7.7h6c1.6 2.8 3.7 4.9 6.3 6.3 2.6 1.4 5.8 2.1 9.6 2.1s6.9-.7 9.5-2.1c2.6-1.4 4.4-3.2 5.5-5.3 1.1-2.1 1.7-5.5 1.7-10.3V97c-2.1 2.6-4.6 4.6-7.6 6.1-3 1.4-6.2 2.1-9.6 2.1-3.9 0-7.7-1-11.1-2.9-3.5-2-6.2-4.6-8.1-7.9-1.9-3.3-2.8-7-2.8-10.9 0-4 1-7.7 3-11.1 2-3.4 4.7-6.1 8.2-8.1 3.5-2 7.2-3 11-3 3.2 0 6.2.7 9 2s5.5 3.5 8 6.6v-7.7zm-16.3 4.2c-3.1 0-6 .8-8.7 2.3-2.7 1.5-4.8 3.6-6.3 6.3-1.5 2.7-2.3 5.6-2.3 8.7 0 4.7 1.6 8.6 4.7 11.7 3.2 3.1 7.2 4.6 12.3 4.6 5.1 0 9.2-1.5 12.2-4.6 3.1-3 4.6-7.1 4.6-12 0-3.2-.7-6.1-2.1-8.7-1.4-2.5-3.4-4.5-6-6s-5.4-2.3-8.4-2.3zM656.8 62.2h5.8l14.7 33 14.3-33h5.9l-25.6 58.6h-5.8l8.3-18.9-17.6-39.7z" />
        </g>
        <g fill={textColor}>
            <path d="M452.2 171.7c-.1-.3-.2-.6-.3-1.1-.1-.4-.1-.9-.2-1.4-.3.4-.6.8-.9 1.1-.3.3-.7.7-1.1.9-.4.3-.9.5-1.4.6-.5.2-1 .2-1.6.2-1 0-1.9-.1-2.7-.4-.8-.3-1.5-.7-2.1-1.2-.6-.6-1-1.2-1.3-2s-.5-1.8-.5-2.8c0-1.1.2-2.1.6-3 .4-.9.9-1.7 1.7-2.4.7-.7 1.7-1.2 2.8-1.6 1.1-.4 2.4-.6 3.9-.6h2.6v-2.4c0-1.3-.3-2.3-.9-2.9-.6-.6-1.5-.9-2.7-.9-.6 0-1.1.1-1.6.3-.5.2-.9.4-1.2.8-.3.3-.6.7-.7 1.1-.2.4-.2.9-.2 1.3h-3.7c0-.8.2-1.6.5-2.4.4-.8.9-1.5 1.5-2.1.7-.6 1.5-1.1 2.4-1.5.9-.4 2-.6 3.2-.6 1 0 2 .1 2.9.4.9.2 1.6.7 2.2 1.2.6.6 1.1 1.3 1.5 2.1.3.9.5 1.9.5 3.2V167.9c0 .4.1.8.1 1.2.1.4.1.8.2 1.2.1.4.2.7.3 1v.3h-3.8zm-4.9-2.9c.5 0 1-.1 1.5-.2.5-.2.9-.3 1.2-.6.4-.2.7-.5 1-.8.3-.3.5-.6.7-1v-5.4h-1.9c-.9 0-1.7.1-2.4.3-.7.2-1.3.5-1.8.8-.5.4-.9.8-1.2 1.4-.3.5-.4 1.2-.4 1.9s.1 1.3.2 1.7c.1.5.3.8.6 1.1.3.3.6.5 1.1.6.3.1.8.2 1.4.2zM475.1 159.8v11.9h-3.8v-30.3h9.7c1.5 0 2.8.2 3.9.7 1.1.5 2.1 1.1 2.8 1.9.8.8 1.3 1.8 1.7 2.9.4 1.1.6 2.4.6 3.7 0 1.5-.2 2.8-.6 3.9s-1 2.1-1.7 2.9c-.8.8-1.7 1.4-2.8 1.8-1.1.4-2.4.6-3.9.6h-5.9zm0-3.2h5.8c.9 0 1.7-.1 2.4-.4.7-.3 1.2-.7 1.6-1.2.4-.5.7-1.1.9-1.9.2-.7.3-1.5.3-2.4 0-.8-.1-1.5-.3-2.3-.2-.7-.5-1.4-.9-1.9-.4-.6-1-1-1.6-1.3-.7-.3-1.5-.5-2.4-.5h-5.8v11.9zM498.7 159.8v11.9h-3.8v-30.3h9.7c1.5 0 2.8.2 3.9.7 1.1.5 2.1 1.1 2.8 1.9.8.8 1.3 1.8 1.7 2.9.4 1.1.6 2.4.6 3.7 0 1.5-.2 2.8-.6 3.9-.4 1.1-1 2.1-1.7 2.9-.8.8-1.7 1.4-2.8 1.8-1.1.4-2.4.6-3.9.6h-5.9zm0-3.2h5.8c.9 0 1.7-.1 2.4-.4.7-.3 1.2-.7 1.6-1.2.4-.5.7-1.1.9-1.9.2-.7.3-1.5.3-2.4 0-.8-.1-1.5-.3-2.3-.2-.7-.5-1.4-.9-1.9-.4-.6-1-1-1.6-1.3-.7-.3-1.5-.5-2.4-.5h-5.8v11.9zM522.4 168.4h11.9v3.3h-15.7v-30.3h3.8v27zM555.8 169c.5 0 1.1-.1 1.5-.2.5-.2.9-.4 1.3-.8s.7-.8.9-1.4c.2-.5.4-1.2.4-2h3.5c0 1.1-.3 2.1-.7 3.1-.4.9-1 1.7-1.7 2.4s-1.5 1.2-2.4 1.5c-.9.4-1.9.5-2.9.5-1.5 0-2.7-.2-3.8-.7-1.1-.5-2-1.2-2.7-2-.7-.9-1.2-2-1.6-3.3-.3-1.3-.5-2.8-.5-4.4v-2.5c0-1.6.2-3.1.5-4.4.3-1.3.9-2.4 1.6-3.3.7-.9 1.6-1.6 2.7-2 1.1-.5 2.3-.7 3.8-.7 1.1 0 2.2.2 3.1.6.9.4 1.7.9 2.4 1.6.7.7 1.2 1.6 1.6 2.6.4 1 .6 2.2.6 3.4H560c-.1-1.7-.5-2.9-1.2-3.7-.7-.8-1.7-1.2-3-1.2-1 0-1.8.2-2.4.5-.6.3-1.1.8-1.5 1.5-.4.6-.6 1.4-.8 2.3-.1.9-.2 1.9-.2 3v2.5c0 1.1.1 2.1.2 3 .1.9.4 1.7.8 2.3.4.6.9 1.1 1.5 1.5.6.1 1.5.3 2.4.3zM566.9 159.4c0-1.8.2-3.3.7-4.6.5-1.3 1.1-2.4 1.9-3.3.8-.9 1.7-1.6 2.8-2 1.1-.5 2.2-.7 3.4-.7 1.2 0 2.4.2 3.4.7 1.1.5 2 1.1 2.8 2 .8.9 1.4 2 1.9 3.3.5 1.3.7 2.9.7 4.6v2.1c0 1.7-.2 3.3-.7 4.6-.5 1.3-1.1 2.4-1.9 3.3-.8.9-1.7 1.6-2.8 2-1.1.4-2.2.7-3.4.7-1.2 0-2.4-.2-3.4-.7-1.1-.4-2-1.1-2.8-2-.8-.9-1.4-2-1.9-3.3-.5-1.3-.7-2.9-.7-4.6v-2.1zm3.7 2.1c0 1.2.1 2.3.4 3.3.3.9.6 1.7 1.1 2.3.5.6 1 1.1 1.6 1.4.6.3 1.3.5 2 .5 3.3 0 5-2.5 5-7.5v-2.1c0-1.2-.1-2.3-.4-3.2-.3-.9-.6-1.7-1.1-2.3-.5-.6-1-1.1-1.6-1.4-.6-.3-1.3-.5-2-.5s-1.4.2-2 .5c-.6.3-1.1.8-1.6 1.4-.4.6-.8 1.4-1.1 2.3-.3.9-.4 2-.4 3.2v2.1zM592.6 149.2l.1 2.1c.7-.8 1.4-1.4 2.3-1.8.9-.4 1.9-.7 3.1-.7 1.1 0 2.2.3 3.1.8.9.5 1.6 1.3 2.2 2.5.6-1 1.4-1.8 2.4-2.4 1-.6 2.1-.9 3.5-.9 1 0 1.9.2 2.7.5.8.3 1.5.8 2 1.5s1 1.5 1.2 2.5c.3 1 .4 2.2.4 3.7v14.8H612V157c0-.9-.1-1.7-.3-2.4-.2-.6-.4-1.1-.8-1.5-.3-.4-.7-.6-1.2-.8-.5-.1-1-.2-1.6-.2s-1.1.1-1.6.4c-.5.2-.8.6-1.2 1-.3.4-.6.9-.8 1.5-.2.6-.3 1.2-.4 1.8v15.1h-3.7v-14.8c0-.9-.1-1.6-.3-2.2-.2-.6-.4-1.1-.8-1.5-.3-.4-.7-.7-1.2-.9-.5-.2-1-.3-1.6-.3-1 0-1.9.3-2.5.8-.6.5-1.1 1.2-1.5 2v16.9h-3.7v-22.5h3.8zM637.4 161.5c0 3.6-.6 6.2-1.9 8-1.3 1.7-3.1 2.6-5.4 2.6-1.2 0-2.2-.2-3-.7-.9-.4-1.6-1.1-2.2-1.9v10.8h-3.7v-31.2h3.3l.2 2.5c.6-.9 1.3-1.7 2.2-2.2.9-.5 1.9-.7 3.1-.7 1.2 0 2.3.2 3.2.6.9.4 1.7 1.1 2.3 1.9.6.9 1.1 2 1.4 3.3.3 1.3.5 2.9.5 4.8v2.2zm-3.6-2.1c0-2.5-.4-4.4-1.2-5.6-.8-1.2-2-1.8-3.7-1.8-1 0-1.8.2-2.4.7-.7.5-1.2 1.1-1.6 1.9v11.7c.4.8.9 1.4 1.6 1.9.6.5 1.5.7 2.5.7 1.7 0 2.9-.6 3.7-1.8.8-1.2 1.2-3.1 1.2-5.6v-2.1zM653.8 171.7c-.1-.3-.2-.6-.3-1.1-.1-.4-.1-.9-.2-1.4-.3.4-.6.8-.9 1.1-.3.3-.7.7-1.1.9-.4.3-.9.5-1.4.6-.5.2-1 .2-1.6.2-1 0-1.9-.1-2.7-.4-.8-.3-1.5-.7-2-1.2-.6-.6-1-1.2-1.3-2-.3-.8-.5-1.8-.5-2.8 0-1.1.2-2.1.6-3 .4-.9.9-1.7 1.7-2.4.7-.7 1.7-1.2 2.8-1.6 1.1-.4 2.4-.6 3.9-.6h2.6v-2.4c0-1.3-.3-2.3-.9-2.9-.6-.6-1.5-.9-2.7-.9-.6 0-1.1.1-1.6.3-.5.2-.9.4-1.2.8-.3.3-.6.7-.7 1.1-.2.4-.2.9-.2 1.3h-3.7c0-.8.2-1.6.5-2.4.4-.8.9-1.5 1.5-2.1.7-.6 1.5-1.1 2.4-1.5.9-.4 2-.6 3.2-.6 1 0 2 .1 2.9.4.9.2 1.6.7 2.2 1.2.6.6 1.1 1.3 1.5 2.1.3.9.5 1.9.5 3.2V167.9c0 .4.1.8.1 1.2.1.4.1.8.2 1.2.1.4.2.7.3 1v.3h-3.9zm-4.9-2.9c.5 0 1-.1 1.5-.2.5-.2.9-.3 1.2-.6.4-.2.7-.5 1-.8.3-.3.5-.6.7-1v-5.4h-1.9c-.9 0-1.7.1-2.4.3-.7.2-1.3.5-1.8.8-.5.4-.9.8-1.2 1.4-.3.5-.4 1.2-.4 1.9s.1 1.3.2 1.7c.1.5.3.8.6 1.1.3.3.6.5 1.1.6.3.1.8.2 1.4.2zM666.1 149.2l.1 2.4c.7-.9 1.5-1.6 2.4-2.1.9-.5 1.9-.7 3.1-.7.9 0 1.7.1 2.5.4.7.3 1.4.8 1.9 1.4.5.7.9 1.5 1.2 2.5.3 1 .4 2.3.4 3.8v14.8H674v-14.8c0-1.8-.3-3-.9-3.8-.6-.7-1.5-1.1-2.7-1.1-.9 0-1.7.3-2.5.9-.7.6-1.3 1.4-1.8 2.4v16.4h-3.7v-22.5h3.7zM689.4 165.6l4.1-16.4h3.9l-7.5 26c-.2.6-.4 1.2-.7 1.8-.3.7-.7 1.3-1.1 1.8-.5.6-1 1-1.7 1.4-.6.4-1.4.6-2.2.6h-.5c-.2 0-.4-.1-.5-.1-.2 0-.4-.1-.5-.1-.2 0-.3-.1-.4-.1v-3.1c.1 0 .2 0 .4.1h.4c.5 0 1-.1 1.4-.2.4-.1.8-.3 1.1-.6.3-.3.6-.7.9-1.1.2-.5.5-1.1.7-1.7l.6-2.2-6.6-22.3h4l4.2 16.2z" />
        </g>
    </chakra.svg>)
}
